import { useState, useEffect, Suspense } from "react";
import Spinner from "./components/ui/spinner/Spinner";
import Header from "./components/header/Header";
import LoginContext from "./store/login/LoginContext";
import InactivityModal from "./components/ui/inactivityModal/InactivityModal";
import Login from "./components/login/Login";
import StudyRoom from './components/studyRoom/StudyRoom';
import UserPage from './components/userPage/UserPage';
import AnalyticsPageView from "./components/googleAnalytics/AnalyticsPageView";

function App() {
  const [user, setUser] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [callname, setCallname] = useState("");
  const [method, setMethod] = useState("");
  const [inactive, setInactive] = useState(false);
  const [showStudyRoom, setShowStudyRoom] = useState();
  
  useEffect(() => {
    if (typeof Storage !== "undefined") {
      try {
        const response = localStorage.getItem("EXAMBRIDGE");
        const userData = JSON.parse(response);
        if (!userData) return;

        if (userData.isLoggedIn === "1") {
          setIsLoggedIn(true);
          setCallname(userData.callname);
          if (userData.type === "guest") {
            setUser("guest");
            setShowStudyRoom(true);
          } else {
            setUser("registered-user");
          }
        } else {
          setIsLoggedIn(false);
          setCallname();
        }
      } catch (err) {
        console.log("Error detected", err);
        alert(
          "It looks like your browser is in Private Mode or does not support session saving. For the best experience, please sign in again or switch to normal browsing mode."
        );
        setIsLoggedIn(false);
        setCallname();
      }
    } else {
      console.log("Undefined detected", err);
      alert(
        "It looks like your browser is in Private Mode or does not support session saving. For the best experience, please sign in again or switch to normal browsing mode."
      );
      setIsLoggedIn(false);
      setCallname();
    }
  }, []);
  
  const contactUsHandler = () => {
    alert("Contacting us!!!");
  };

  const saveDataInLocalStorage = async (data) => {
    if (typeof Storage !== "undefined") {
      // localStorage is supported
      try {
        localStorage.setItem(
          "EXAMBRIDGE",
          JSON.stringify({
            isLoggedIn: "1",
            type: data.user,
            callname: data.callname,
            method: data.method,
          })
        );
        //console.log('Data successfully saved');
      } catch (err) {
        console.log(err, "Failed to save data");
      }
    }
  };

  useEffect(()=> {
    let idleTime = 0;
    let warning = setInterval(alarm, 60000); // 60000 = 1 minute
    let events = ['click', 'mousemove', 'keydown', 'scroll'];
    
    events.forEach(function (event) {
      document.addEventListener(event, () => {
        idleTime = 0;
      });
    });

    function alarm() {
      if (isLoggedIn) {
        idleTime += 1;
        if (idleTime > 600) { //Use 10 minutes
          setInactive(true);
        }
        if (idleTime > 900) { //Use 15 minutes
          clearTimeout(warning);
          setInactive(false);
          logOutHandler();
        }
      }
    }
  }, [isLoggedIn]);

  const guestHandler = (callname) => {
    setCallname(callname);
    setUser("guest");
    setIsLoggedIn(true);
    saveDataInLocalStorage({ user: "guest", callname, method: "" });
    setShowStudyRoom(true);
  };

  const registeredUserHandler = (userData) => {
    setIsLoggedIn(true);
    setUser("registered-user");
    setMethod(userData.method);
    saveDataInLocalStorage({ user: "registered-user", ...userData });
    if (userData.callname) {
      setCallname(userData.callname);
      setShowStudyRoom(true);
    } else {
      alert(
        "Missing credentials!!!",
        "You did not complete your registration\nHence you do not have back up help in case you forget your password\nClick on Security and Profile updates to add security back up data and other personal data respectively"
      );
    }
  };

  const logOutHandler = async () => {
    if (typeof Storage !== "undefined") {
      // localStorage is supported
      localStorage.removeItem("EXAMBRIDGE");
    }     
    setIsLoggedIn(false);
    setUser();
    setShowStudyRoom(); //due store in UserPage
    window.location.reload(true);
  };

  const studyRoomRequestHandler = () => setShowStudyRoom(true);

  const closeStudyRoomHandler = () => setShowStudyRoom(false);

  const ctxData = {
    isLoggedIn: isLoggedIn,
    onLogout: logOutHandler,
    user: user,
    callname: callname,
    method: method,
  };

  return (
    <>
      <LoginContext.Provider value={ctxData}>        
        {showSpinner && <Spinner />}
        {inactive && <InactivityModal onClose={() => setInactive(false)} />}
        {!showSpinner && (
          <main>
            <Header />
            {(!user || !isLoggedIn) && (
              <Login
                onGuestSubmission={guestHandler}
                onContactUs={contactUsHandler}
                onLoggedIn={registeredUserHandler}
                onLogout={logOutHandler}
              />
            )}
            {user && isLoggedIn && !showStudyRoom && (
              <UserPage
                onStudyRoom={studyRoomRequestHandler}
                onLogout={logOutHandler}
              />
            )}
            {user && isLoggedIn && showStudyRoom && (
              <Suspense fallback={<p>Opening your study room ...</p>}>
                <StudyRoom
                  onCloseStudyRoom={closeStudyRoomHandler}
                  onLogout={logOutHandler}
                />
              </Suspense>
            )}
          </main>
        )}
      </LoginContext.Provider>
    </>
  );
}

export default App;
